import {
  Box,
  Modal,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Stack,
  Button,
  TextField,
  InputAdornment,
  iconButtonClasses,
} from "@mui/material";
import {
  CalendarIcon,
  DatePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useState } from "react";
import ButtonOne from "../common/normal-button";
import ButtonTwo from "../common/dashboard-button";

const FilterModal = ({ open, onClose, children, onReset }) => {
  const handleReset = () => {
    onReset();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          backgroundColor: "background.paper",
          p: 3,
          maxWidth: "90%",
          width: 400,
          borderRadius: 2,
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        <Typography
          variant="h4"
          fontWeight="bold"
          sx={{ mb: 3, textDecoration: "underline" }}
        >
          Filters
        </Typography>
        <Stack spacing={3} sx={{ mb: 3 }}>
          {children}
        </Stack>
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
          <ButtonTwo variant="outlined" onClick={handleReset} title={"Reset Filters"}>
            {/* Reset Filters */}
          </ButtonTwo>
          <ButtonOne variant="contained" onClick={onClose} title={"Apply"}>
            {/* Apply */}
          </ButtonOne>
        </Box>
      </Box>
    </Modal>
  );
};

const FilterModalItem = ({
  name,
  data = [],
  onChange,
  value = "",
  type = "select",
  icon = null,
  renderItem = null,
  renderValue = null
}) => {
  const commonStyles = {
    // color: "primary.main",
    // '& .MuiOutlinedInput-notchedOutline': {
    //   borderColor: "primary.main",
    // },
    // '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    //   borderColor: "primary.main",
    //   borderWidth: "2px",
    // },
    // '& .MuiSvgIcon-root': {
    //   color: "primary.main",
    // },
    // '& .MuiInputLabel-root': {
    //   color: "primary.main",
    //   '&.Mui-focused': {
    //     color: "primary.main",
    //   },
    // },
  };

  const captilazeFirstLetter = (str) => {
    if (typeof str !== "string") return str;
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  if (type === "date") {
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
        <DatePicker
          disableFuture
          label={name}
          sx={{ width: "100%" }}
          value={value}
          onChange={(e) => onChange(e)}
          slotProps={{
            textField: {
              InputProps: {
                startAdornment: (
                  <InputAdornment position="start">{icon}</InputAdornment>
                ),
              },
            },
          }}
          renderInput={(params) => (
            <TextField {...params} sx={commonStyles} size="small" />
          )}
        />
      </LocalizationProvider>
    );
  }

  return (
    <FormControl fullWidth>
      <InputLabel
        sx={
          {
            //   color: "primary.main",
            //   "&.Mui-focused": {
            //     color: "primary.main",
            //   },
          }
        }
      >
        {name}
      </InputLabel>
      <Select
        value={value}
        onChange={(e) => onChange(e)}
        label={name}
        defaultValue=""
        sx={commonStyles}
        startAdornment={
          icon && <InputAdornment position="start">{icon}</InputAdornment>
        }
        renderValue={renderValue}
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        {data.map((item) =>
          renderItem ? (
            renderItem(item)
          ) : (
            <MenuItem key={item} value={item}>
              {captilazeFirstLetter(item)}
            </MenuItem>
          )
        )}
      </Select>
    </FormControl>
  );
};

export { FilterModal, FilterModalItem };
